import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import MailOutlinedIcon from '@mui/icons-material/MailOutlined'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import { useContext } from 'react'
import { logOutHandler } from '@/utils/functions'
import { useRouter } from 'next/router'
import { SeekerContext } from '@/context/SeekerContext'
import { SharedContext } from '@/context/SharedContext'

function SeekerHeaderDesktop({ setShowToast, setShowMenu }) {
  const { loginDetails, setLoginDetails, cookie } = useContext(SharedContext)

  const { setLogInOpen, isJobProfileCreated } = useContext(SeekerContext)
  const router = useRouter()
  async function logUserOutHandler() {
    await logOutHandler({ setLoginDetails: setLoginDetails, loginDetails, cookie })
    setShowMenu(false)
    setLogInOpen(false)
  }

  async function loginHandler() {
    setShowMenu(false)

    setLogInOpen(true)
  }
  const handleCopy = async (text, title) => {
    try {

      await navigator.clipboard.writeText(text)
      setShowToast((p) => {
        return {
          ...p,
          status: !p.status,
          text: title
        }
      })
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }
  
  const iconStyles = {
    width: '24px',
    height: '24px',
    color: '#666666'
  }
  let helpItems = [
    {
      id: 1,
      title: 'Email us at',
      copyText: 'Email address',
      subText: 'jobssupport@getlokalapp.com',
      footer: '',
      icon: <MailOutlinedIcon style={iconStyles} />,
      link: 'mailto:jobssupport@getlokalapp.com'
    }
  ]
  return (
    <div
      id="seeker-header-desktop"
      className="fixed top-[12%] right-[2.5%] z-50 w-[30%] rounded-[24px] bg-white"
      style={{
        border: '1px solid rgba(0, 0, 0, 0.08)'
      }}
    >
      <div id="head" className="p-[24px]">
        <div id="heading">
          <h3 className="m-[0px] font-noto-sans text-[24px] font-bold text-greyTitleBase900">
            {loginDetails?.isLogIn ? `Hi,${loginDetails?.name}` : 'Your account'}
          </h3>

          <div id="item-list" className="mt-[16px] flex flex-col justify-center space-y-[15px]">
            {loginDetails?.isLogIn ? (
              <div
                className="flex items-center font-noto-sans text-[14px] text-greyTitleBase900 cursor-pointer gap-[5px]"
                onClick={logUserOutHandler}
              >
                {' '}
                <LogoutOutlinedIcon sx={{ width: '24px', height: '24px',color:"#989898" }} /> Logout
              </div>
            ) : (
              <div
                className="flex items-center font-noto-sans text-[14px] text-greyTitleBase900 gap-[5px] cursor-pointer"
                onClick={loginHandler}

              >
                {' '}
                <LogoutOutlinedIcon sx={{ width: '24px', height: '24px',color:"#989898" }} /> Login
              </div>
            )}
            {loginDetails?.isLogIn && <div className='flex items-center font-noto-sans text-[14px] text-greyTitleBase900 gap-[5px] cursor-pointer' onClick={()=>{
                router.push('/create_profile')
            }}>
            <AccountCircleOutlinedIcon sx={{
                color:"#989898"
            }}/> {isJobProfileCreated ? 'My profile' : 'Create profile'}
            </div>}
          </div>
        </div>
      </div>
      <div id="help" className="custom-gradient-help w-[100%] rounded-b-[24px] p-[16px]">
        <div className="text-[14px] font-[600] text-greyTitleBase900">Need help?</div>
        <ul id="help-items" className="p-[0px]">
          {helpItems.map((item, id) => {
            return (
              <li className="flex items-center justify-between gap-[12px] rounded-[12px] font-noto-sans text-[14px] font-[400] text-greyTitleBase900"
              key={id}
              >
                <div className="mt-[14px] flex space-x-[12px]">
                  <div
                    id="icon"
                    className="border-x-greyDisabledBackground50 rounded-[12px] p-[8px]"
                  >
                    {item.icon}
                  </div>
                  <div id="content" className="flex flex-col space-y-[4px]">
                    <div>
                      {' '}
                      <a
                        href={item.link}
                        className="text-[14px] text-greyTertiaryBase500 no-underline"
                      >
                        {item.title}
                      </a>
                    </div>{' '}
                    <div>
                      {' '}
                      <a
                        href={item.link}
                        className="text-[14px] text-greyTitleBase900 no-underline"
                      >
                        {item.subText}
                      </a>
                    </div>
                    <div className="text-[12px] text-greyTertiaryLight400"> {item.footer}</div>
                  </div>
                </div>

                <div
                  id="copy"
                  onClick={() => {
                    handleCopy(item.subText, item.copyText)
                  }}
                >
                  <ContentCopyOutlinedIcon style={iconStyles} />
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default SeekerHeaderDesktop
